import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import ItemDetails from 'components/item/item-tile/ItemDetails';
import ItemName from 'components/item/item-tile/ItemName';
import ItemPhoto from 'components/item/item-tile/ItemPhoto';
import { HeartIcon } from 'components/item/item-tile/tileIcons';
import { ItemSellingMethod, TrackedItemDto } from 'services/item/itemService.dto';

import { MyActivityItemStatusOverlay } from './MyActivityItemStatusOverlay';

const BorderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${theme.color.borderGray};
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
  overflow: hidden;
`;

const ImageContainer = styled.div`
  width: 100%;
  position: relative;
`;

const HiddenItemContainer = styled(BorderContainer)`
  cursor: auto;
`;

const HiddenItemPlaceholder = styled.div`
  width: 100%;
  aspect-ratio: 1;
  background-color: ${theme.color.black};
  border-radius: 5px;
`;

const SellingMethodBadge = styled.div`
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 2;
  border-radius: 4px;
  background-color: ${theme.color.white};
  padding: 2px 6px;
  font-size: 11px;
  line-height: 14px;
  font-weight: 700;
  color: ${theme.color.black};
`;

interface Props {
  item: TrackedItemDto;
  onClick: (itemId: number, orderId?: number) => void;
}

const SellingMethodLabel = ({ sellingMethod }: { sellingMethod: ItemSellingMethod }) => {
  const { t } = useTranslation('myProfile');

  return (
    <SellingMethodBadge data-testid={'selling-method-badge'}>
      {t(`my-activity.items.selling-method.${sellingMethod.toLowerCase()}`)}
    </SellingMethodBadge>
  );
};

export const MyActivityItemTile = ({ item, onClick }: Props) => {
  const { t } = useTranslation('myProfile');
  const { itemDetails } = item;

  if (!itemDetails)
    return (
      <HiddenItemContainer>
        <ImageContainer>
          <HiddenItemPlaceholder />
          <MyActivityItemStatusOverlay />
        </ImageContainer>
        <ItemName title={t('my-activity.item-hidden')} />
      </HiddenItemContainer>
    );
  return (
    <BorderContainer onClick={() => onClick(item.id, item.orderId)} data-testid={'item-tile'}>
      <ImageContainer>
        <ItemPhoto image={itemDetails.imageUrlList[0]} />
        <SellingMethodLabel sellingMethod={itemDetails.sellingMethod} />
        <HeartIcon />
        <MyActivityItemStatusOverlay item={itemDetails} />
      </ImageContainer>
      <ItemName title={itemDetails.title} />
      <ItemDetails item={itemDetails} />
    </BorderContainer>
  );
};
